import React, { useMemo } from "react";
import {
  buildMonthGrid,
  dayKey,
  getWeekdayLabels,
  groupEventsByDay,
  isSameDay,
  startOfDayLocal,
} from "./calendarGrid";
import EventosAgrupados from "./EventosAgrupados";
import { consultaDeFeriado } from "./feriados";
import {
  DayCell,
  DayEvents,
  DayNumber,
  DayNumberRow,
  FeriadoChip,
  MonthGrid,
  WeekdayCell,
  WeekdayRow,
} from "./styles";

const MAX_VISIBLE_EVENTS = 3;

export default function MonthView({
  feriadoDe = consultaDeFeriado(),
  cursor,
  events,
  weekStartsOn,
  onSelectEvent,
  onOpenDay,
}) {
  const today = useMemo(() => startOfDayLocal(new Date()), []);
  const year = cursor.getFullYear();
  const month = cursor.getMonth();
  const grid = useMemo(
    () => buildMonthGrid(year, month, weekStartsOn),
    [year, month, weekStartsOn]
  );
  const weekdays = useMemo(() => getWeekdayLabels(weekStartsOn), [weekStartsOn]);
  const eventsByDay = useMemo(() => groupEventsByDay(events), [events]);

  return (
    <>
      <WeekdayRow>
        {weekdays.map((label) => (
          <WeekdayCell key={label}>{label}</WeekdayCell>
        ))}
      </WeekdayRow>
      <MonthGrid>
        {grid.map((cell) => {
          const eventsForDay = eventsByDay.get(cell.key) || [];
          const isToday = isSameDay(cell.date, today);
          const isWeekend = cell.date.getDay() === 0 || cell.date.getDay() === 6;
          // Feriado recebe a mesma cor de fundo do domingo/fim de
          // semana (dia nao util). A lista vem de `feriadoDe` (feriados.js).
          const nomeFeriado = cell.inMonth ? feriadoDe(cell.date) : null;
          const ehFeriado = Boolean(nomeFeriado);

          return (
            <DayCell
              key={cell.key}
              $outside={!cell.inMonth}
              $weekend={(isWeekend && cell.inMonth) || ehFeriado}
              $clickable={eventsForDay.length > 0}
              title={ehFeriado ? `Feriado: ${nomeFeriado}` : undefined}
              onClick={() => {
                if (eventsForDay.length > 0) onOpenDay?.(cell.date, eventsForDay);
              }}
            >
              <DayNumberRow>
                <DayNumber $today={isToday} $outside={!cell.inMonth}>
                  {cell.date.getDate()}
                </DayNumber>
              </DayNumberRow>
              {nomeFeriado && (
                <FeriadoChip title={`Feriado: ${nomeFeriado}`}>
                  <span aria-hidden="true">📅</span> {nomeFeriado}
                </FeriadoChip>
              )}
              {eventsForDay.length > 0 && (
                <DayEvents>
                  <EventosAgrupados
                    eventos={eventsForDay}
                    maxAmbientes={MAX_VISIBLE_EVENTS}
                    $outside={!cell.inMonth}
                    onSelectEvent={onSelectEvent}
                    onMais={() => onOpenDay?.(cell.date, eventsForDay)}
                  />
                </DayEvents>
              )}
            </DayCell>
          );
        })}
        {/* REF-10: a grade do mes e SEMPRE exibida, mesmo sem entregas
            planejadas. Antes um EmptyMessage com grid-row/column "1 / -1"
            cobria toda a grade e escondia os dias. */}
      </MonthGrid>
    </>
  );
}

// Helper exported para que outras views possam reaproveitar
export { dayKey };
